import * as React from 'react';

const SvgExclamationCircleOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M4.219 12.76a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0m8.25-9.75c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.366 9.75-9.75-4.366-9.75-9.75-9.75m1 6.75a1 1 0 0 0-2 0v3.75a1 1 0 1 0 2 0zm-1 5.75a1 1 0 0 0-1 1v.007a1 1 0 0 0 1 1h.007a1 1 0 0 0 1-1v-.008a1 1 0 0 0-1-1z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgExclamationCircleOutlined;
